import MainMenu from '@/views/MainMenu.vue'
import type { RouteRecordRaw } from 'vue-router'

const globalSearchRoute: RouteRecordRaw = {
  path: '/search',
  name: 'globalSearch',
  component: MainMenu,
  // redirect: { name: 'globalSearchIndex' },
  meta: {
    seo: {
      title: 'MapleStory | Search',
    },
  },
  children: [
    {
      path: '',
      name: 'globalSearchIndex',
      component: () => import('@/views/GlobalSearchView.vue'),
      meta: {
        hideOnMenu: true,
        menuTitle: 'Search',
        fullPage: true,
        seo: {
          description: 'as ',
          keywords: 'asd',
        },
        gaPageType: 'global search',
      },
    },
  ],
}

export default globalSearchRoute
